var _module = require('./index');

_module.controller('MortgageCalculatorCtrl', [
    function() {
        var vm = this;

        vm.services = {
            showMortgageInsurance: function() {
                return vm.data.downPaymentPercentage < 0.2;
            }
        }
    }
])

_module.directive('mortgageCalculator', [function() {
    return {
        restrict: 'E',
        scope: {
            data: '=',
            calculator: '=',
            report: '=',
            onDownPaymentUpdate: '&',
            onDownPaymentPercentageUpdate: '&',
            onLoanTypeUpdate: '&',
            onPrequalifyClick: '&',
            onResetClick: '&',
            onInteraction: '&'
        },
        bindToController: true,
        controllerAs: 'vm',
        controller: 'MortgageCalculatorCtrl',
        templateUrl: 'js/components/modals/templates/mortgage-calculator.tmpl.html'
    }
}]);
